module.exports = __webpack_public_path__ + "static/media/config-light.92f66e10.svg";